<template>
  <div>
    <v-row class="button-top">
      <v-col :cols="12">
        <v-btn
          depressed
          color="primary"
          class="button-base"
          @click="openModalView"
        >
          Заполнить реквизиты из профиля
        </v-btn>
      </v-col>
    </v-row>
    <BaseModalView v-model="dialog" :divider="false" max-width="1200px">
      <template v-slot:title>Добавление реквизитов счета</template>
      <template v-slot:body>
        <AccountDetailsTable
          :data="bankDetails"
          :addButtonShow="false"
          :selectable="true"
          ref="accountDetailsTable"
        />
      </template>
      <template v-slot:buttons>
        <v-btn depressed class="button-base-white mr-5" @click="dialog = false">
          Отмена
        </v-btn>
        <v-btn depressed color="primary" class="button-base" @click="add">
          Заполнить реквизиты из профиля
        </v-btn>
      </template>
    </BaseModalView>
  </div>
</template>

<script>
import BaseModalView from '@/components/base/BaseModalView.vue';
import { getBankDetails } from '@/api/profile';
import AccountDetailsTable from '@/components/profile/personal-details/account/AccountDetailsTable.vue';

export default {
  name: 'LoadAccountBankDetails',
  components: { AccountDetailsTable, BaseModalView },
  data: () => ({
    bankDetails: [],
    dialog: false,
  }),
  methods: {
    async openModalView() {
      this.dialog = true;
      this.bankDetails = await getBankDetails();
    },
    async add() {
      this.bankDetails = await this.$refs.accountDetailsTable.upload();
      this.$emit('change', this.bankDetails);
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss"></style>
